export default "__VITE_ASSET__a99f5c62__"